"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Header_1 = __importDefault(require("./components/Header"));
var Hero_1 = __importDefault(require("./components/Hero"));
var About_1 = __importDefault(require("./components/About"));
var Skills_1 = __importDefault(require("./components/Skills"));
var Projects_1 = __importDefault(require("./components/Projects"));
var Contact_1 = __importDefault(require("./components/Contact"));
var Footer_1 = __importDefault(require("./components/Footer"));
function App() {
    var _a = (0, react_1.useState)(window.innerWidth), width = _a[0], setWidth = _a[1];
    var handleWindowResize = function () { return setWidth(window.innerWidth); };
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'undefined') {
            window.addEventListener("resize", handleWindowResize);
        }
        return function () { return window.removeEventListener("resize", handleWindowResize); };
    }, [width, handleWindowResize]);
    var _b = (0, react_1.useState)(0), yPosition = _b[0], setYPosition = _b[1];
    var trackYPos = function () { return setYPosition(window.scrollY); };
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', trackYPos);
        }
        return function () { return window.removeEventListener('scroll', trackYPos); };
    }, [yPosition, trackYPos]);
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(Header_1.default, { width: width }),
        react_1.default.createElement(Hero_1.default, { yPosition: yPosition, width: width }),
        react_1.default.createElement(About_1.default, null),
        react_1.default.createElement(Skills_1.default, null),
        react_1.default.createElement(Projects_1.default, null),
        react_1.default.createElement(Contact_1.default, null),
        react_1.default.createElement(Footer_1.default, null)));
}
exports.default = App;
